import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>The above example shows how decisions can be driven by
                                                different ethical standards, the impact
                                                of which can be extremely important in the business world.
                                                This tool is about <span className="green"><strong>how to make
        ethical decisions</strong></span> and aims to help you understand how ethics can directly impact business
                                                performance. The key sources of ethical standards are
                                                highlighted so they can be used as a
                                                framework for you when making ethical decisions.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>WHAT’S ALL THE FUSS ABOUT?
                                            </div>
                                            <p>Each and every one of us makes hundreds of decisions every
                                                day. From mulling over important
                                                decisions about company strategy and operations to agonising
                                                over what to have for lunch – we
                                                have all developed our own tried and tested methods for
                                                deciding what or how to do things.</p>
                                            <div className="border_subtitle">So, why should making ethical
                                                decisions be any different?
                                            </div>
                                            <p>Well, in a nutshell, it’s not! Many of the cognitive
                                                processes we use to make ‘everyday’ decisions
                                                can also be applied to making decisions with ethical
                                                consequences.<a className="superscripttext supLinesapce"
                                                                href="further_info.php?course=300"><sup>2</sup></a> However,
                                                a little extra
                                                knowledge can go a long way and this tool will help you to
                                                understand the ethical implications of
                                                your decisions in more detail and help you make those
                                                choices where ‘doing the right thing’ is of
                                                utmost importance.</p>
                                            <div className="border_subtitle">What are ethics?</div>
                                            <p>Before we begin, it is important to clarify what we mean by
                                                ‘ethics’. Ethics are codes of ‘good’
                                                behaviour in terms of moral duty and obligation. Applied to
                                                business, they underpin the guiding
                                                principles of culture and behaviour.</p>
                                            <p>Ethical behaviour in business is critical. Over recent years,
                                                several high-profile scandals have
                                                demonstrated the importance of making ethical decisions.
                                                Consider companies such as Enron,
                                                WorldCom and Barings Bank, all of which have been involved
                                                in financial scandal to one degree
                                                or another as a direct result of a series of unethical
                                                decisions made by those in positions of
                                                authority and power. It may sound a little ‘over the top’,
                                                but these allegations, and others like them,
                                                raise concerns about the moral fibre of companies and
                                                potentially threaten the nature of the free
                                                market economy.</p>
                                            <p>Taking a less extreme view, the ethical foundations for your
                                                decisions can play a significant role
                                                in business success. For example, you may be faced with the
                                                dilemma of using cheap foreign
                                                labour in response to price competition. On the one hand,
                                                the use of cheap labour will allow you
                                                to retain your competitive edge and survive in the
                                                marketplace, reducing the need for redundancies.
                                                However, on the other hand, the use of cheap labour may be
                                                morally wrong and help to drive
                                                down wages within the industry.</p>
                                            <p>So, making ethical decisions – not just about ‘doing the
                                                right thing’ and avoiding the courts – is
                                                about weighing up the ethical consequences of different
                                                actions and using your judgement to
                                                reach a decision. Read on to learn more about making ethical
                                                decisions.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>DIFFERENT APPROACHES TO ETHICAL DECISIONS
                                            </div>
                                            <p>It is important to note that ethics are not based on
                                                feelings, religion, law, accepted social practice
                                                or science. Philosophers and ethicists have been debating
                                                the basis of ethics since Socrates
                                                suggested that people will naturally do what is good, if
                                                they are aware of what is right. Since then,
                                                philosophy has broadly condensed the basis of ethical
                                                decisions into five different approaches,
                                                each of which should be considered when making a
                                                decision.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}